
import PublicLayout from '../pages/Layouts/PublicLayout/Index';
import Login from '../pages/Auth/Login/Index';
import PublicRoute from './publicRoute';
import { Navigate, RouteObject } from 'react-router-dom';
import Register from '../pages/Auth/Register/Index';
import GoogleAuthCallback from '../pages/Auth/Google/Index';

const publicRoutes: RouteObject[] = [
    {
        path: '/',
        element: <Navigate to="/auth/login" replace />,
    },
    {
        path: '/auth',
        element: <PublicLayout />,
        children: [
            {
                path: 'login',
                element: (
                    <PublicRoute>
                        <Login />
                    </PublicRoute>
                ),
            },
            {
                path: 'register',
                element: (
                    <PublicRoute>
                        <Register />
                    </PublicRoute>
                ),
            },
        ],
    },
    {
        path: '/oauth',
        element: <PublicLayout />,
        children: [
            {
                path: 'login/callback',
                element: (
                    <PublicRoute>
                        <GoogleAuthCallback />
                    </PublicRoute>
                ),
            },
        ],
    }
]

export default publicRoutes;
